import { useEffect } from "react";
import { ArrowLeft } from "@phosphor-icons/react";

export default function LegalPage({ page }) {
  useEffect(() => {
    document.title = `${page.title} — Rupora`;
    window.scrollTo(0, 0);
    return () => {
      document.title = "Rupora — USDT to INR Exchange";
    };
  }, [page.title]);

  return (
    <div className="min-h-screen bg-night font-sans text-paper antialiased" data-testid={`legal-${page.path.slice(1)}`}>
      <header className="border-b border-line/70 bg-night/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-5 sm:px-8">
          <a href="/" className="logo-chip" data-testid="legal-logo">
            <img src="/assets/logo-wordmark.png" alt="Rupora" className="h-6 w-auto" />
          </a>
          <a
            href="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm font-medium text-mist transition-colors hover:text-brand-300"
          >
            <ArrowLeft size={15} /> Back to home
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-5 py-16 sm:px-8 lg:py-20">
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-brand-400">Legal</p>
        <h1 className="mt-4 font-display text-4xl font-semibold tracking-tighter sm:text-5xl">{page.title}</h1>
        <p className="mt-3 text-sm text-mist/70">Last updated: {page.updated}</p>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-mist">{page.intro}</p>

        <div className="mt-12 space-y-10">
          {page.sections.map((s, i) => (
            <section key={s.h} data-testid={`legal-section-${i + 1}`}>
              <h2 className="flex items-baseline gap-3 font-display text-xl font-semibold tracking-tight text-paper">
                <span className="text-sm font-semibold text-brand-400">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-mist">{s.body}</p>
            </section>
          ))}
        </div>

        <div className="mt-16 rounded-2xl border border-line bg-pine p-6">
          <p className="text-sm leading-relaxed text-mist">
            Questions about this document? Reach the team through the support section in the Rupora app.
          </p>
        </div>
      </main>

      <footer className="border-t border-line">
        <div className="mx-auto max-w-4xl px-5 py-8 sm:px-8">
          <p className="text-xs text-mist/50">© 2026 Rupora. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
